module.exports = __webpack_public_path__ + "img/intro_no.96adbb93.svg";